<template>
  <PageWrapper
    :logo="true"
    theme="transparent embedded"
    :logo-white="true"
    :route-name="pages.AUTH_EMBED_LOGIN"
  >
    <span slot="headerBottom"></span>
    <transition name="slide-fade" mode="out-in">
      <router-view class="child"></router-view>
    </transition>
  </PageWrapper>
</template>

<script>
export default {
  name: "auth"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
